import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const role = sessionStorage.getItem('role');
  
  if (role !== 'ADMIN') {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
